import { LenderName } from '@nemuru-eng/js-api-client';

import { AuthenticationType } from '../types/AuthenticationType';

export const authenticationTypeMap = new Map<LenderName, AuthenticationType>([
  [LenderName.NEMURU, AuthenticationType.NO_AUTH],
  [LenderName.APLAZAME, AuthenticationType.PASSWORD],
  [LenderName.SEQURA, AuthenticationType.PASSWORD],
  [LenderName.SEQURA_QUIX, AuthenticationType.PASSWORD],
  [LenderName.FLOA, AuthenticationType.PASSWORD],
  [LenderName.CAIXABANK, AuthenticationType.NO_AUTH],
  [LenderName.BS, AuthenticationType.PASSWORD],
  [LenderName.BBVA, AuthenticationType.PASSWORD],
  [LenderName.COFIDIS, AuthenticationType.NO_AUTH],
  [LenderName.SOYOU, AuthenticationType.PASSWORD],
  [LenderName.PEPPER, AuthenticationType.PASSWORD],
  [LenderName.KUESKI, AuthenticationType.PASSWORD],
  [LenderName.KOIN, AuthenticationType.PASSWORD],
  [LenderName.FINONLINE, AuthenticationType.OAUTH_2],
  [LenderName.CETELEM, AuthenticationType.OAUTH_2],
  [LenderName.ABANCA, AuthenticationType.PASSWORD],
]);
